import type { Theme } from '../types'

export const themes: Record<string, Theme> = {
  default: {
    id: 'default',
    name: 'Default Theme',
    styles: {
      backgroundColor: '#000000',
      textColor: '#ffffff',
      primaryColor: '#2563eb',
      secondaryColor: '#475569',
      controlsBackground: 'rgba(0, 0, 0, 0.5)',
      controlsColor: '#ffffff',
      loadingBackground: '#000000',
      loadingColor: '#ffffff',
      sceneListBackground: 'rgba(0, 0, 0, 0.7)',
      sceneListColor: '#ffffff',
      sceneListActiveBackground: '#2563eb',
      sceneListActiveColor: '#ffffff'
    }
  },
  light: {
    id: 'light',
    name: 'Light Theme',
    styles: {
      backgroundColor: '#ffffff',
      textColor: '#1e293b',
      primaryColor: '#3b82f6',
      secondaryColor: '#64748b',
      controlsBackground: 'rgba(255, 255, 255, 0.9)',
      controlsColor: '#1e293b',
      loadingBackground: '#ffffff',
      loadingColor: '#1e293b',
      sceneListBackground: 'rgba(255, 255, 255, 0.9)',
      sceneListColor: '#1e293b',
      sceneListActiveBackground: '#3b82f6',
      sceneListActiveColor: '#ffffff'
    }
  },
  dark: {
    id: 'dark',
    name: 'Dark Theme',
    styles: {
      backgroundColor: '#1e293b',
      textColor: '#f8fafc',
      primaryColor: '#60a5fa',
      secondaryColor: '#94a3b8',
      controlsBackground: 'rgba(30, 41, 59, 0.9)',
      controlsColor: '#f8fafc',
      loadingBackground: '#1e293b',
      loadingColor: '#f8fafc',
      sceneListBackground: 'rgba(30, 41, 59, 0.9)',
      sceneListColor: '#f8fafc',
      sceneListActiveBackground: '#60a5fa',
      sceneListActiveColor: '#f8fafc'
    }
  },
  minimal: {
    id: 'minimal',
    name: 'Minimal Theme',
    styles: {
      backgroundColor: '#000000',
      textColor: '#ffffff',
      primaryColor: '#ffffff',
      secondaryColor: '#cccccc',
      controlsBackground: 'transparent',
      controlsColor: '#ffffff',
      loadingBackground: '#000000',
      loadingColor: '#ffffff',
      sceneListBackground: 'transparent',
      sceneListColor: '#ffffff',
      sceneListActiveBackground: 'rgba(255, 255, 255, 0.2)',
      sceneListActiveColor: '#ffffff'
    }
  }
}
